export default function events( el ) {
	if ( ! el ) {
		return;
	}
	const slider = el.querySelector( '.b-event-items' );
	if ( slider ) {
		const flkty = new Flickity( slider, {
			cellAlign: 'left',
			pageDots: false,
			contain: true,
			prevNextButtons: false, // Disable default prev/next buttons
		} );

		// Custom previous button
		const prevButton = el.querySelector( '.b-event-prev' );
		if ( prevButton ) {
			prevButton.addEventListener( 'click', function() {
				flkty.previous();
			} );
		}

		// Custom next button
		const nextButton = el.querySelector( '.b-event-next' );
		if ( nextButton ) {
			nextButton.addEventListener( 'click', function() {
				flkty.next();
			} );
		}

		// Add event listeners to page dots
		const pageDots = el.querySelectorAll( '[data-nav]' );
		pageDots.forEach( ( dot ) => {
			dot.addEventListener( 'click', function() {
				const month = dot.getAttribute( 'data-nav' );
				const targetSlide = slider.querySelector( `[data-month="${ month }"]` );
				if ( targetSlide ) {
					const index = flkty.getCellElements().indexOf( targetSlide );
					flkty.select( index );
				}
			} );
		} );

		// Add is-selected class to the button of the first slide's month.
		const firstSlide = flkty.getCellElements()[ 0 ];
		if ( firstSlide ) {
			const firstMonth = firstSlide.getAttribute( 'data-month' );
			const firstDot = el.querySelector( `[data-nav="${ firstMonth }"]` );
			if ( firstDot ) {
				firstDot.classList.add( 'is-selected' );
			}
		}

		// Add is-inactive class to page dots if the month is not in the slides.
		pageDots.forEach( ( dot ) => {
			const month = dot.getAttribute( 'data-nav' );
			const targetSlide = slider.querySelector( `[data-month="${ month }"]` );
			if ( ! targetSlide ) {
				dot.classList.add( 'is-inactive' );
			} else {
				dot.classList.remove( 'is-inactive' );
			}
		} );

		// Update is-selected class on page dots
		flkty.on( 'select', function() {
			const selectedSlide = flkty.selectedElement;
			const selectedMonth = selectedSlide.getAttribute( 'data-month' );
			pageDots.forEach( ( dot ) => {
				if ( dot.getAttribute( 'data-nav' ) === selectedMonth ) {
					dot.classList.add( 'is-selected' );
				} else {
					dot.classList.remove( 'is-selected' );
				}
			} );
		} );
	}
}
